module.exports = __webpack_public_path__ + "static/media/televet-logo-splashscreen.5ad84f6b.png";